
import { namespace } from 'vuex-class';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { OfferPresentationType, OfferPresentationTypes } from '@/interfaces/titles';

import { ModalHelper } from '@/helpers/modal-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import ChipButton from '@/ui-components/ChipButton.vue';
import ChipButtons from '@/ui-components/ChipButtons.vue';
import CountrySwitcherModal from '@/components/buybox/country-switcher/CountrySwitcherModal.vue';

// BUYBOX_EXP_4
import { buyboxExp4TrackBuyBoxFilterClick } from '@/components/experiments/buybox-exp-4/tracking';
// BUYBOX_EXP_4

// BUYBOX_EXP_5
import { BuyBoxFilterOptions } from '@/components/experiments/buybox-exp-5/utils';
import { buyboxExp5TrackBuyBoxFilterClick } from '@/components/experiments/buybox-exp-5/tracking';
// BUYBOX_EXP_5

const Language = namespace('language');
const User = namespace('user');

@Component({
	name: 'BuyBoxFilter',
	components: {
		ChipButton,
		ChipButtons,
	},
})
export default class BuyBoxFilter extends Vue {
	@Prop({ default: false }) isInModal: boolean;
	@Prop({ default: null }) defaultPresentationType: OfferPresentationType | null;
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];

	// BUYBOX_EXP_4
	@Prop() buyboxExp4ValidationPassed: boolean;
	// BUYBOX_EXP_4

	// BUYBOX_EXP_5
	@Prop() buyboxExp5ValidationPassed: boolean;
	// BUYBOX_EXP_5

	@Language.State webLocale: string;
	@Language.Getter countryEmoji: string;

	@User.Getter buyboxPresentationType: OfferPresentationType;
	@User.Action setBuyboxPresentationType: (payload: {
		presentationType: OfferPresentationType | null;
		additionalContexts?: SnowplowContext[];
	}) => void;

	// APPLE_QUALITY_TV
	@Emit('filterChange')
	onFilterChange() {}
	// APPLE_QUALITY_TV

	get filterOptions() {
		const options = [
			{
				label: this.$t('WEBAPP_QUALITY_BESTPRICE'),
				value: null,
				isQuality: false,
			},
			{
				label: this.$t('WEBAPP_BUYBOX_FREE_FILTER'),
				value: OfferPresentationType.FREE,
				isQuality: false,
			},
		] as const;

		const qualityOptions = OfferPresentationTypes.filter(g => g.isQuality);
		return options.concat(qualityOptions as any[]);
	}

	openCountrySwitcherModal() {
		ModalHelper.openModal(CountrySwitcherModal, { closable: true });
		TrackingHelper.trackEvent('userinteraction', { action: 'country_selector_clicked' }, this.additionalContexts);
	}

	// BUYBOX_EXP_4
	// BUYBOX_EXP_5
	handleFilterClick(payload: {
		presentationType: OfferPresentationType | null;
		additionalContexts?: SnowplowContext[];
	}) {
		this.setBuyboxPresentationType(payload);
		// APPLE_QUALITY_TV
		this.onFilterChange();
		// APPLE_QUALITY_TV

		if (this.buyboxExp4ValidationPassed) {
			buyboxExp4TrackBuyBoxFilterClick(
				[...(payload.additionalContexts || [])],
				payload.presentationType as OfferPresentationType | BuyBoxFilterOptions | null
			);
		}

		if (this.buyboxExp5ValidationPassed) {
			buyboxExp5TrackBuyBoxFilterClick(
				[...(payload.additionalContexts || [])],
				payload.presentationType as OfferPresentationType | BuyBoxFilterOptions | null
			);
		}
	}
	// BUYBOX_EXP_4
	// BUYBOX_EXP_5

	mounted() {
		// for Apple TV+ search ads
		if (this.$route.query.monetization_types === 'free') {
			return this.setBuyboxPresentationType({ presentationType: OfferPresentationType.FREE });
		}

		if (!this.defaultPresentationType) return;

		this.setBuyboxPresentationType({
			presentationType: this.defaultPresentationType,
			additionalContexts: this.additionalContexts,
		});
	}
}
